import script from "./MemberDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./MemberDetails.vue?vue&type=script&setup=true&lang=js"

import "./MemberDetails.vue?vue&type=style&index=0&id=390fd061&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-390fd061"]])

export default __exports__